import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SchedulerState } from './state';

export const selectScheduler = createFeatureSelector<SchedulerState>('scheduler')

export const selectSchedulerErrors = createSelector(
  selectScheduler,
  (scheduler: SchedulerState) => scheduler && scheduler.errors
)

export const selectIsPrintView = createSelector(
  selectScheduler,
  (scheduler: SchedulerState) => scheduler && scheduler.printView
)

export const selectShowConsolidatedAppointments = createSelector(
  selectScheduler,
  (scheduler: SchedulerState) => scheduler && scheduler.showConsolidatedAppointments
)
